import { motion } from "framer-motion";
import "./About.css";
import heroImg from "../assets/about-hero.webp";
import coachImg from "../assets/coach-photo.webp";
import GalleryCarousel from "../components/GalleryCarousel";
// import gallery1 from "../assets/gallery1.webp";
// import gallery2 from "../assets/gallery2.webp";
// import gallery3 from "../assets/gallery3.webp";

export default function About() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section
        className="about-hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        <div className="overlay"></div>
        <motion.div
          className="hero-text"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Building Stronger Players. One Smash at a Time.</h1>
          <p>
            Badminton isn’t just a sport — it’s a lifestyle of discipline,
            growth, and joy. We help players of every level reach their next
            milestone.
          </p>
        </motion.div>
      </section>

      {/* Who We Are */}
      <section className="about-story">
        <motion.img
          src={coachImg}
          alt="Coach teaching badminton"
          className="coach-photo"
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        />
        <motion.div
          className="story-text"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>Meet Coach -- Ronit R Sharma</h2>
          <p>
            Hi, I’m Ronit Sharma — a passionate badminton player with over 10
            years of competitive experience. I started training at the age of 9
            and have since represented Chandigarh and the University of
            Melbourne in major tournaments across India and Australia. My
            coaching focuses on building strong technique, strategic thinking,
            and mental resilience. I love helping players grow their game with
            discipline, confidence, and an aggressive yet smart playstyle.
          </p>
          <p>
            Each session combines structured drills, strength work, and tactical
            insight — all wrapped in a fun, friendly environment that inspires
            improvement.
          </p>
        </motion.div>
      </section>

      {/* Vision */}
      <section className="about-vision">
        <motion.div
          className="vision-content"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2>Our Vision</h2>
          <p>
            Our mission is simple — to help players discover the joy of
            progress. Badminton is about building focus, confidence, and lasting
            friendships, one rally at a time.
          </p>
        </motion.div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose">
        <h2>Why Choose SmashKaro</h2>
        <div className="choose-grid">
          <div className="card">
            <h3> Personalized Coaching</h3>
            <p>
              Every player is unique — our sessions adapt to your goals and
              progress.
            </p>
          </div>
          <div className="card">
            <h3> Technique + Fitness</h3>
            <p>
              Our programs balance stamina, agility, and precision for maximum
              results.
            </p>
          </div>
          <div className="card">
            <h3> Friendly Community</h3>
            <p>
              Train with others who share your energy, drive, and passion for
              the game.
            </p>
          </div>
        </div>
      </section>

      <section className="about-video">
        <h2>Inside Our Training</h2>
        <div className="video-container">
          <video controls playsInline autoPlay muted loop>
            <source
              src={require("../assets/Untitled design.mp4")}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>

      {/* Gallery Carousel */}
      <section className="carousel-section">
        <GalleryCarousel />
      </section>
    </div>
  );
}
